import { TeamView, TeamViewSchema } from "@common/types/views/teamViews";
import { omit } from "@common/helpers/objects";
import { createDefaultTeamView } from "@components/organizationView/team/views/DefaultTeamView";
import { ORGANIZATION_USER_CACHE_KEYS } from "../useOrganizationUserCache";
import { useViewStore } from "./useViewStore";

const viewSanitizer = (view?: TeamView) => {
    if (!view) {
        return undefined;
    }

    return { ...view, filters: omit(view.filters, ["search"]) };
};

interface UseTeamViewStoreOptions {
    defaultView?: TeamView;
    parentFilters?: TeamView["filters"];
    cacheKey?: ORGANIZATION_USER_CACHE_KEYS;
}

export function useTeamViewStore({
    defaultView,
    parentFilters,
    cacheKey,
}: UseTeamViewStoreOptions = {}) {
    return useViewStore<TeamView>({
        defaultView: defaultView ?? createDefaultTeamView(),
        viewSchema: TeamViewSchema,
        parentFilters,
        cacheKey,
        viewSanitizer,
    });
}
